/*
 * @Author: cn1994
 * @Date: 2024-02-21 15:46:34
 * @LastEditors: cn1994
 * @LastEditTime: 2024-03-03 15:07:45
 * @Description: file content
 */
const routes = [
  { // 任务详情
    path: '/taskDetail',
    name: 'taskDetail',
    meta: {
      title: '任务详情',
      volcengine: true,
    },
    component: () => import('../pages/taskDetail/index.vue'),
  },
  // 全部任务详情
  {
    path: "/taskDetail/allTaskDetail",
    name: 'taskDetail/allTaskDetail',
    meta: {
      title: '任务详情',
      hasBack: true,
      level: 2
    },
    component: () => import('../pages/taskDetail/allTaskDetail.vue'),
  },
  // 全部任务详情
  {
    path: "/groups/allTaskDetail",
    name: 'groups/allTaskDetail',
    meta: {
      title: '班级任务详情',
      hasBack: true,
      level: 3
    },
    component: () => import('../pages/taskDetail/allTaskDetail.vue'),
  },
  

  // 班级详细详情
  // {
  //   path: "/taskDetailQp",
  //   name: 'taskDetailQp',
  //   meta: { title: '班级任务'},
  //   component: () => import('../pages/taskDetailQp/index.vue'),
  // },
  // {
  //   path: "/taskDetailQp/classDetail",
  //   name: 'taskDetailQp/classDetail',
  //   meta: { title: '班级任务', hasBack: true, level: 2 },
  //   component: () => import('../pages/taskDetailQp/classDetail.vue'),
  // },
  // // 任务详细详情
  // {
  //   path: "/taskDetailQp/courseTaskDetail",
  //   name: 'taskDetailQp/courseTaskDetail',
  //   meta: { title: '任务详情', hasBack: true, level: 3 },
  //   component: () => import('../pages/taskDetailQp/courseTaskDetail.vue'),
  // },
  // // 任务详细详情
  // {
  //   path: "/taskDetailQp/taskDetail",
  //   name: 'taskDetailQp/taskDetail',
  //   meta: { title: '任务详情', hasBack: true, level: 3 },
  //   component: () => import('../pages/taskDetailQp/taskDetail.vue'),
  // },
]
export default routes;